import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

export function setupI18Next(resources: any) {
    return i18next.use(initReactI18next).init({
        resources,
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });
}

export const setupLocales = (langs: any[]) => {
    const resources = Object.entries(langs).reduce((acc, [lang, translation]) => {
        return {
            ...acc,
            [lang]: { translation },
        };
    }, {});
    return setupI18Next(resources);
};
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

export function setupI18Next(resources: any) {
    return i18next.use(initReactI18next).init({
        resources,
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });
}

export const setupLocales = (langs: any[]) => {
    const resources = Object.entries(langs).reduce((acc, [lang, translation]) => {
        return {
            ...acc,
            [lang]: { translation },
        };
    }, {});
    return setupI18Next(resources);
};
